(() => {
  'use strict';
  if (window.SingleItemCart) return;
  const config = window.SingleItemCartConfig || {};
  const originalFetch = window.fetch.bind(window);
  const messages = {
    de: {
      limit: 'Pro Bestellung ist nur ein Artikel möglich. Entferne zuerst den vorhandenen Artikel aus deinem Warenkorb.',
      reduce: 'Dein Warenkorb darf insgesamt nur einen Artikel enthalten. Reduziere den Warenkorb auf einen Artikel oder leere ihn und wähle neu.',
      retry: 'Der Warenkorb konnte nicht geprüft werden. Bitte lade die Seite neu und versuche es erneut.',
      clear: 'Warenkorb leeren und neu auswählen',
      clearFailed: 'Der Warenkorb konnte nicht geleert werden. Bitte lade die Seite neu und versuche es erneut.',
      close: 'Schließen'
    },
    ro: {
      limit: 'Poți comanda un singur articol. Elimină mai întâi articolul existent din coș.',
      reduce: 'Coșul poate conține în total un singur articol. Redu coșul la un singur articol sau golește-l și alege din nou.',
      retry: 'Coșul nu a putut fi verificat. Reîncarcă pagina și încearcă din nou.',
      clear: 'Golește coșul și alege din nou',
      clearFailed: 'Coșul nu a putut fi golit. Reîncarcă pagina și încearcă din nou.',
      close: 'Închide'
    },
    pt: {
      limit: 'Só é permitido um artigo por encomenda. Remove primeiro o artigo que já está no carrinho.',
      reduce: 'O carrinho só pode conter um artigo no total. Reduz a quantidade para um artigo ou esvazia o carrinho e escolhe novamente.',
      retry: 'Não foi possível verificar o carrinho. Atualiza a página e tenta novamente.',
      clear: 'Esvaziar o carrinho e escolher novamente',
      clearFailed: 'Não foi possível esvaziar o carrinho. Atualiza a página e tenta novamente.',
      close: 'Fechar'
    },
    hr: {
      limit: 'Po narudžbi je dopušten samo jedan artikl. Najprije ukloni postojeći artikl iz košarice.',
      reduce: 'Košarica može sadržavati ukupno samo jedan artikl. Smanji količinu na jedan artikl ili isprazni košaricu i odaberi ponovno.',
      retry: 'Košaricu nije moguće provjeriti. Ponovno učitaj stranicu i pokušaj ponovno.',
      clear: 'Isprazni košaricu i odaberi ponovno',
      clearFailed: 'Košaricu nije moguće isprazniti. Ponovno učitaj stranicu i pokušaj ponovno.',
      close: 'Zatvori'
    },
    hu: {
      limit: 'Rendelésenként csak egy termék választható. Előbb távolítsd el a kosárban lévő terméket.',
      reduce: 'A kosár összesen csak egy terméket tartalmazhat. Csökkentsd a mennyiséget egyre, vagy ürítsd ki a kosarat, és válassz újra.',
      retry: 'A kosár ellenőrzése sikertelen. Töltsd újra az oldalt, és próbáld meg ismét.',
      clear: 'Kosár ürítése és új választás',
      clearFailed: 'A kosár ürítése sikertelen. Töltsd újra az oldalt, és próbáld meg ismét.',
      close: 'Bezárás'
    },
    cs: {
      limit: 'V jedné objednávce může být jen jedna položka. Nejprve odeber stávající položku z košíku.',
      reduce: 'Košík může obsahovat celkem jen jednu položku. Sniž množství na jednu položku nebo vyprázdni košík a vyber znovu.',
      retry: 'Košík se nepodařilo zkontrolovat. Obnov stránku a zkus to znovu.',
      clear: 'Vyprázdnit košík a vybrat znovu',
      clearFailed: 'Košík se nepodařilo vyprázdnit. Obnov stránku a zkus to znovu.',
      close: 'Zavřít'
    },
    pl: {
      limit: 'W jednym zamówieniu można kupić tylko jeden produkt. Najpierw usuń produkt znajdujący się już w koszyku.',
      reduce: 'Koszyk może zawierać łącznie tylko jeden produkt. Zmniejsz ilość do jednej sztuki lub opróżnij koszyk i wybierz ponownie.',
      retry: 'Nie udało się sprawdzić koszyka. Odśwież stronę i spróbuj ponownie.',
      clear: 'Opróżnij koszyk i wybierz ponownie',
      clearFailed: 'Nie udało się opróżnić koszyka. Odśwież stronę i spróbuj ponownie.',
      close: 'Zamknij'
    },
    en: {
      limit: 'Only one item is allowed per order. Remove the existing item from your cart first.',
      reduce: 'Your cart can contain only one item in total. Reduce it to one item or clear the cart and choose again.',
      retry: 'We could not check your cart. Reload the page and try again.',
      clear: 'Clear cart and choose again',
      clearFailed: 'We could not clear your cart. Reload the page and try again.',
      close: 'Close'
    }
  };
  const language = () => String(document.documentElement.lang || config.language || 'en').toLowerCase().split('-')[0];
  const copy = () => messages[language()] || messages.en;
  let queue = Promise.resolve();
  let count = Number(config.count) || 0;
  let applying = false;
  let clearPending = false;

  function notice(message) {
    let box = document.querySelector('[data-single-item-feedback]');
    if (!box) {
      box = document.createElement('div');
      box.dataset.singleItemFeedback = '';
      box.className = 'single-item-feedback';
      box.setAttribute('role', 'alert');
      const text = document.createElement('span');
      text.dataset.singleItemMessage = '';
      const clear = document.createElement('button');
      clear.type = 'button';
      clear.dataset.singleItemClear = '';
      clear.className = 'single-item-clear';
      const close = document.createElement('button');
      close.type = 'button';
      close.textContent = '×';
      close.setAttribute('aria-label', copy().close);
      close.addEventListener('click', () => { box.hidden = true; });
      box.append(text, clear, close);
      document.body.append(box);
    }
    const text = box.querySelector('[data-single-item-message]');
    if (text.textContent !== message) text.textContent = message;
    const clear = box.querySelector('[data-single-item-clear]');
    clear.hidden = count <= 1;
    clear.disabled = clearPending;
    if (clear.textContent !== copy().clear) clear.textContent = copy().clear;
    box.hidden = false;
  }

  function applyCartState(nextCount) {
    count = nextCount;
    if (!document.body || applying) return;
    applying = true;
    document.querySelectorAll('[data-single-item-cart-notice]').forEach(node => {
      node.hidden = count <= 1;
      const text = node.querySelector('[data-single-item-cart-notice-message]');
      if (text && text.textContent !== copy().reduce) text.textContent = copy().reduce;
    });
    document.querySelectorAll('[data-single-item-clear]').forEach(button => {
      button.disabled = clearPending;
      if (button.textContent !== copy().clear) button.textContent = copy().clear;
    });
    document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach(button => {
      if (count > 1) {
        if (!button.disabled) button.dataset.singleItemDisabled = 'true';
        button.disabled = true;
      } else if (button.dataset.singleItemDisabled === 'true') {
        button.disabled = count === 0;
        delete button.dataset.singleItemDisabled;
      }
    });
    document.querySelectorAll('.additional-checkout-buttons').forEach(node => {
      if (count > 1) {
        if (!node.hidden) node.dataset.singleItemHidden = 'true';
        node.hidden = true;
      } else if (node.dataset.singleItemHidden === 'true') {
        node.hidden = false;
        delete node.dataset.singleItemHidden;
      }
    });
    applying = false;
  }

  async function readCart(signal) {
    const response = await originalFetch(`${config.cartUrl || '/cart'}.js`, {
      credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store', signal
    });
    if (!response.ok) throw new Error('Cart unavailable');
    const cart = await response.json();
    if (!Array.isArray(cart.items) || !Number.isInteger(cart.item_count) || cart.item_count < 0 ||
      cart.items.some(item => !Number.isInteger(item.quantity) || item.quantity < 1) ||
      cart.items.reduce((sum, item) => sum + item.quantity, 0) !== cart.item_count) throw new Error('Invalid cart');
    applyCartState(cart.item_count);
    return cart;
  }

  const quantity = value => {
    if (typeof value === 'number') return Number.isSafeInteger(value) && value >= 0 ? value : null;
    if (typeof value === 'string' && /^\d+$/.test(value)) {
      const parsed = Number(value);
      return Number.isSafeInteger(parsed) ? parsed : null;
    }
    return null;
  };

  async function requestData(input, init, url) {
    let body = init?.body;
    if (body === undefined && input instanceof Request) {
      const request = input.clone();
      const contentType = request.headers.get('Content-Type') || '';
      body = /multipart\/form-data|application\/x-www-form-urlencoded/i.test(contentType) ? await request.formData() : await request.text();
    }
    if (body === undefined || body === '' || body === null) {
      if (!url?.search) throw new Error('Missing cart payload');
      body = url.searchParams;
    } else if (url && Array.from(url.searchParams.keys()).some(key => /^(id|line|quantity|items\[|updates(?:\[|$))/.test(key))) {
      // Conflicting body/query quantities have uncertain precedence. Fail closed instead of undercounting an add.
      throw new Error('Ambiguous body and query');
    }
    if (body instanceof FormData || body instanceof URLSearchParams) {
      const result = Object.fromEntries(body.entries());
      const updates = {};
      const items = {};
      for (const [key, value] of body.entries()) {
        const match = key.match(/^updates\[([^\]]+)\]$/);
        if (match) updates[match[1]] = value;
        const item = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
        if (item) {
          items[item[1]] ||= {};
          items[item[1]][item[2]] = value;
        }
      }
      if (Object.keys(updates).length) result.updates = updates;
      if (body.has('updates[]')) result.updates = body.getAll('updates[]');
      if (Object.keys(items).length) result.items = Object.values(items);
      return result;
    }
    if (typeof body !== 'string' || !body) throw new Error('Unsupported cart request');
    try { return JSON.parse(body); } catch (_error) {
      return requestData(input, { body: new URLSearchParams(body) });
    }
  }

  function proposedCount(action, data, cart) {
    if (!data || typeof data !== 'object' || Array.isArray(data)) throw new Error('Invalid cart payload');
    if (action === 'add') {
      const items = data.items || [data];
      if (!Array.isArray(items) || !items.length) throw new Error('Invalid cart add');
      let added = 0;
      for (const item of items) {
        if (!item?.id) throw new Error('Missing add variant');
        const amount = quantity(item.quantity ?? 1);
        if (amount === null || amount < 1) throw new Error('Invalid add quantity');
        added += amount;
      }
      return { total: cart.item_count + added, increases: true };
    }
    if (action === 'change') {
      const amount = quantity(data.quantity);
      const line = quantity(data.line);
      const matches = line ? [cart.items[line - 1]].filter(Boolean) : cart.items.filter(item => item.key === String(data.id) || String(item.variant_id) === String(data.id));
      const item = matches.length === 1 ? matches[0] : null;
      if (amount === null || !item) throw new Error('Invalid cart change');
      return { total: cart.item_count - item.quantity + amount, increases: amount > item.quantity };
    }
    if (data.updates === undefined) return { total: cart.item_count, increases: false }; // Notes, attributes, and discount updates do not add items.
    let total = cart.item_count;
    let increases = false;
    if (Array.isArray(data.updates)) {
      if (data.updates.length !== cart.items.length) throw new Error('Invalid cart updates');
      const updatedTotal = data.updates.reduce((sum, value, index) => {
        const amount = quantity(value);
        if (amount === null) throw new Error('Invalid update quantity');
        if (amount > cart.items[index].quantity) increases = true;
        return sum + amount;
      }, 0);
      return { total: updatedTotal, increases };
    }
    if (!data.updates || typeof data.updates !== 'object') throw new Error('Invalid updates');
    const affected = new Set();
    for (const [id, value] of Object.entries(data.updates)) {
      const amount = quantity(value);
      if (amount === null) throw new Error('Invalid update quantity');
      const matches = cart.items.filter(item => item.key === id || String(item.variant_id) === id);
      if (matches.length > 1 || matches.some(item => affected.has(item.key))) throw new Error('Ambiguous update');
      if (matches.length) {
        total += amount - matches[0].quantity;
        if (amount > matches[0].quantity) increases = true;
        affected.add(matches[0].key);
      } else {
        total += amount;
        if (amount > 0) increases = true;
      }
    }
    return { total, increases };
  }

  function rejected(message) {
    notice(message);
    return new Response(JSON.stringify({ status: 422, message, description: message, errors: message }), {
      status: 422, headers: { 'Content-Type': 'application/json; charset=utf-8' }
    });
  }

  function serialized(operation, signal) {
    if (navigator.locks?.request) return navigator.locks.request('cjuuri-single-item-cart', { mode: 'exclusive', ...(signal ? { signal } : {}) }, operation);
    const result = queue.then(operation, operation);
    queue = result.catch(() => {});
    return result;
  }

  async function clearCart() {
    if (clearPending || count <= 1) return;
    clearPending = true;
    applyCartState(count);
    try {
      await serialized(async () => {
        // This destructive action runs only after the customer clicks the explicit clear button.
        const response = await originalFetch(`${config.cartUrl || '/cart'}/clear.js`, {
          method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Cart clear failed');
        const cart = await response.json();
        if (cart.item_count !== 0 || !Array.isArray(cart.items) || cart.items.length !== 0) throw new Error('Cart remains nonempty');
        applyCartState(0);
        location.reload();
      });
    } catch (_error) {
      notice(copy().clearFailed);
    } finally {
      clearPending = false;
      applyCartState(count);
    }
  }

  window.fetch = function(input, init) {
    const url = new URL(input instanceof Request ? input.url : String(input), location.href);
    const method = String(init?.method || (input instanceof Request ? input.method : 'GET')).toUpperCase();
    const match = url.pathname.match(/\/cart\/(add|change|update)(?:\.(?:js|json))?\/?$/);
    if (url.origin !== location.origin || method !== 'POST' || !match) return originalFetch(input, init);
    const signal = init?.signal || (input instanceof Request ? input.signal : undefined);
    return serialized(async () => {
      if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');
      try {
        const data = await requestData(input, init, url);
        const cart = await readCart(signal);
        const next = proposedCount(match[1], data, cart);
        // A customer may reduce a pre-existing multi-item cart gradually. Never remove or replace items automatically.
        if (next.total > 1 && (match[1] === 'add' || next.increases)) return rejected(copy().limit);
        const response = await originalFetch(input, init);
        if (response.ok) await readCart(signal).catch(() => {});
        return response;
      } catch (error) {
        if (error?.name === 'AbortError') throw error;
        return rejected(copy().retry);
      }
    }, signal);
  };

  document.addEventListener('click', event => {
    const clear = event.target instanceof Element && event.target.closest('[data-single-item-clear]');
    if (clear) {
      event.preventDefault();
      event.stopImmediatePropagation();
      clearCart();
      return;
    }
    const checkout = event.target instanceof Element && event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    if (checkout && count > 1) {
      event.preventDefault();
      event.stopImmediatePropagation();
      notice(copy().reduce);
    }
  }, true);
  document.addEventListener('submit', event => {
    if (count > 1 && event.submitter?.name === 'checkout') {
      event.preventDefault();
      event.stopImmediatePropagation();
      notice(copy().reduce);
    }
  }, true);
  function start() {
    applyCartState(count);
    if (count > 1) notice(copy().reduce);
    // Shopify section rendering replaces checkout controls after cart changes.
    new MutationObserver(() => applyCartState(count)).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pageshow', () => readCart().catch(() => {}));
  }
  window.SingleItemCart = Object.freeze({ maximum: 1 });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
